import React, { useState, useEffect } from 'react';
import ConvertNumberToWords from '../../constants/ConvertNumberToWords';
import CommonInputWithIcon from '../../../components/Dashboard-res/CommonComponent/CommonInputWithIcon.js';

const InputTypeNumber = props => {
  const {
    name,
    maxLength,
    minLength,
    legendName,
    value,
    onChange,
    onBlur,
    disabled,
    error,
    errorMsg,
    touched,
    stylesContainer,
    legendStyle,
    iconStyle,
    inputStyle,
    onBlurStyle,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    showInText = true,
    rupeeIcon = true
  } = props;

  const [words, setWords] = useState('');
  const [formattedNumber, setFormattedNumber] = useState('');

  const format = val => {
    if (val != NaN && val) {
      const repcomma = val.replace(/,/g, '');
      const convertNum = parseInt(repcomma);
      const res = convertNum
        .toFixed(1)
        .replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
        .toString()
        .split('.')[0];
      return res;
    }
  };
  const handleNumber = e => {
    let number = (e ? e : '')
      .toString()
      .split(',')
      .join('');
    if (!number) {
      setFormattedNumber('');
      setFieldValue(name, '');

      return;
    }
    if (!isNaN(number) || !number) {
      if (
        parseInt(number.length) < (maxLength ? maxLength : 0) &&
        parseInt(number.length) >= (minLength ? minLength : 0)
      ) {
        setWords(ConvertNumberToWords(number));
        setFormattedNumber(format(number));
        setFieldValue(name, number);
      }
    }
  };
  useEffect(() => {
    handleNumber(value);
  }, [value]);
  return (
    <div className="w-full">
      <CommonInputWithIcon
        name={name}
        type='tel'
        legendName={legendName}
        value={formattedNumber}
        onChange={e => {
          handleNumber(e.target.value);
        }}
        onBlur={onBlur}
        disabled={disabled}
        error={error}
        errorMsg={errorMsg}
        touched={touched}
        stylesContainer={stylesContainer}
        legendStyle={legendStyle}
        inputStyle={inputStyle}
        onBlurStyle={onBlurStyle}
        setFieldValue={setFieldValue}
        rupeeIcon={rupeeIcon}
        iconStyle={iconStyle}
      />
      {showInText ? (
        <p className="display_words mt-1 text-xs text-green-500">{words}</p>
      ) : null}
    </div>
  );
};
export default InputTypeNumber;
